import angular  from 'angular'
import uiRouter from 'angular-ui-router'

import component from './home-description.component'

let module = angular.module('homeDescription', [
  uiRouter
])

.component('homeDescription', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/home/description/index.js